import {
   rand,
   randNumber,
   randBoolean,
   randStateAbbr,
   randCounty,
   randCity,
   randCountry,
   randCountryCode,
} from '@ngneat/falso';

import { Country } from '../base/countries';

export const MockCountry = (): Country => ({
   code: randCountryCode(),
   country: randCountry(),
});

export const PostalDetails = (): Country['postalDetails'] => ({
   ...rand([
      { regex: '(^[a-zA-Z][0-9][a-zA-Z] [0-9][a-zA-Z][0-9]$)', postalExample: 'A1Z 0Y9' },
      { regex: '^[0-9]{5,5}$', postalExample: '12345' },
      { regex: '(^[0-9][0-9][0-9][0-9][0-9]-[0-9][0-9][0-9][0-9]$)|(^[0-9][0-9][0-9][0-9][0-9]$)', postalExample: '12345-1234' },
      { regex: '^[a-zA-Z0-9]{1,10}$' },
      { regex: '^[0-9a-zA-Z ]{0,9}$' },
   ]),
   required: randBoolean(),
   maxLength: randNumber({ min: 3, max: 12 }),
});

export const Region = (): Country['regions'][0] => ({ code: randStateAbbr(), region: randCounty() });
export const Regions = (): Country['regions'] => Array.from({ length: randNumber({ min: 1, max: 100 }) }, _ => Region() );

export const Ports = (): Country['ports'] => Array.from({ length: randNumber({ min: 1, max: 100 }) }, _ => randCity() );

export type MockCountryOpts = {
   includeRegions?: boolean,
   includePorts?: boolean,
   includePostalDetails?: boolean,
};

export const MockCountries = ( opts?: MockCountryOpts ) => {
   return Array.from({ length: randNumber({ min: 1, max: 100 }) }, _ => {
      const country = MockCountry();
      if ( opts?.includeRegions ) { country.regions = Regions(); }
      if ( opts?.includePorts ) { country.ports = Ports(); }
      if ( opts?.includePostalDetails ) { country.postalDetails = PostalDetails(); }

      return country;
   });
};
